export function setProductDialogState(field, value) {
  return {
    type: "SET_FIELD_DIALOG",
    dialogName: "editProductDialog",
    field: field,
    value: value,
  };
}

export function setHelpDialogState(field, value) {
  return {
    type: "SET_FIELD_DIALOG",
    dialogName: "helpDialog",
    field: field,
    value: value,
  };
}
